module.exports = __webpack_public_path__ + "img/account_pc_07.c8e151fa.png";